import {FETCH_MOBMENU} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_MOBMENU:
            return action.payload;
        default:
            return state;
    }
}